import { render, staticRenderFns } from "./Pos.vue?vue&type=template&id=322d991e&scoped=true"
import script from "./Pos.vue?vue&type=script&lang=js"
export * from "./Pos.vue?vue&type=script&lang=js"
import style0 from "./Pos.vue?vue&type=style&index=0&id=322d991e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322d991e",
  null
  
)

export default component.exports